import renderBublesChat from "./renderBublesChat";

let historyChat = async () => {
  const containner = document.getElementsByClassName("any_botContent")[0];
  const loader = document.getElementById("loader");

  // Show loader
  loader.style.display = "block";

  const preloader = `<div class="preloader" style="background-image: url(${anyBacken.basePreloader});"><div class="contentPreloader"><img src="${anyBacken.anyLoader}" alt=""/></div></div>`;
  containner.innerHTML += preloader;

  jQuery.ajax({
    type: "POST",
    url: anyBacken.ajaxurl,
    dataType: "text",
    data: "action=historyChat&nonce=" + anyBacken.nonce,
    error: function (jqXHR, textStatus, errorThrown) {
      console.log(jqXHR, textStatus, errorThrown);
      // Hide loader on error
      loader.style.display = "none";
      return;
    },
    success: function (result) {
      const history = JSON.parse(result);
      renderBublesChat(containner, JSON.parse(history), preloader);
      // Hide loader on success
      loader.style.display = "none";
    },
  });
};

export default historyChat;